import React from "react";
import store from "../../Store";
import { connect } from "react-redux";
import { resetFilterParams } from "./FailedSite-Action";
import getGlobalFailedTnx from "../../ajax/actions/failed-site-transactions/globalFailed-get";

class FailedSiteWorker extends React.Component {
  componentDidMount() {
    store.dispatch(resetFilterParams());
    store.dispatch(getGlobalFailedTnx());
  }

  render() {
    return null;
  }
}

function mapStateToProps(state) {
  let { getGlobalFailedTnx } = state;

  return { getGlobalFailedTnx };
}

export default connect(mapStateToProps)(FailedSiteWorker);
